import * as React from 'react'

const SvgShareKnowledgeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.875 15.625h-3.75c-1.036 0-1.875.84-1.875 1.875v1.25h1.25V17.5c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625v1.25h1.25V17.5c0-1.035-.84-1.875-1.875-1.875zM12.5 12.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm3.75 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-12.5.625V12.5H2.5v.625A4.375 4.375 0 006.875 17.5H8.75v-1.25H6.875a3.125 3.125 0 01-3.125-3.125zm8.125-6.875h4.375V7.5h-4.375V6.25zm0-2.5h6.25V5h-6.25V3.75zm0-2.5h6.25V2.5h-6.25V1.25zm-5 5.625h-3.75c-1.036 0-1.875.84-1.875 1.875V10H2.5V8.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625V10h1.25V8.75c0-1.036-.84-1.875-1.875-1.875zM5 6.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5 2.5A1.25 1.25 0 115 5a1.25 1.25 0 010-2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgShareKnowledgeIcon
